import {useContext, useEffect, useRef} from "react";
import { UNSAFE_NavigationContext } from "react-router-dom";
import type { History, Transition } from 'history';


/** TOOD: change args to object like { isBlocked, onBlockedCallback, onNavigatingCallback } */
interface INavigationBlocker {
    (isNavDisabled:() => boolean, onBlockedNavAttemptCallback?:() => void, onNotBlockedNavAttemptCallback?: () => void): {
        retryNavigation: () => void ,
        unblockNavigation: () => void ,
    };
}

const useNavigationBlocker: INavigationBlocker = (isNavDisabled, onBlockedNavAttemptCallback = () => {}, onNotBlockedNavAttemptCallback = () => {}) => {
    const navigator = useContext(UNSAFE_NavigationContext).navigator as History;

    const isBlocked = useRef(false);
    const retryNav = useRef(() => {});
    const unblockNav = useRef(() => {});

    const isNavDisabledRes = isNavDisabled();
    
    /** this calls onBlockedNavAttemptCallback when navigation is blocked */    
    useEffect(() => {

        if (isNavDisabledRes) {
            if (!isBlocked.current) {
                isBlocked.current = true;

                unblockNav.current = navigator.block((transition:Transition) => {
                    retryNav.current = () => {
                        transition.retry();
                    };
                    onBlockedNavAttemptCallback();
                });
            }
        }
        else {
            isBlocked.current = false;
            unblockNav.current();
        }

    }, [isNavDisabledRes, navigator, onBlockedNavAttemptCallback])

    /** this calls onNotBlockedNavAttemptCallback when navigation happens */
    useEffect(() => {
        const unlisten = navigator.listen((...args) => { 
            onNotBlockedNavAttemptCallback();
        });
        return () => {
            unlisten();
        }
    }, [navigator, onNotBlockedNavAttemptCallback])
    

    return {
        retryNavigation: () => {
            isBlocked.current = false;
            unblockNav.current();
            retryNav.current();
        }, 
        unblockNavigation: () => {
            isBlocked.current = false;
            unblockNav.current();
        }
    };
}

export default useNavigationBlocker;
